import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { AttributeInterface } from 'src/app/model/attributes/attribute-interface';
import { PtgAttributeValidationInterface } from 'src/app/model/attributes/ptg-attribute-validation-interface';
import { ValidationInterface } from 'src/app/model/attributes/validation-interface';
import { CertificationInterface } from 'src/app/model/certifications/certification-interface';
import { CommonFeatureInterface } from 'src/app/model/commonFeature/common-feature-interface';
import { ProductCommonFeatureInterface } from 'src/app/model/commonFeature/product-common-feature-interface';
import { ProductTypeGroupFeaturesDisplayInterface, ProductTypeGroupFeatureDisplayInterface } from 'src/app/model/marketplace/product-type-group-features-interface';
import { ProductInterface } from 'src/app/model/products/product-interface';
import { ProductVariantInterface } from 'src/app/model/products/product-variant-interface';
import { VariantVersionInterface } from 'src/app/model/products/variant-version-interface';
import { PtgVersionInterface } from 'src/app/model/ptgs/ptg-version-interface';
import { CommonFeatureService } from 'src/app/services/common-feature-service/common-feature.service';
interface FeatureComparisonRow {
  variantName: string;
  versionName: string;
  features: Set<string>;
  version: VariantVersionInterface;
}
@Component({
    selector: 'app-product-detail-display-feature-summary',
    templateUrl: './product-detail-display-feature-summary.component.html',
    styleUrls: ['./product-detail-display-feature-summary.component.css'],
    standalone: false
})
export class ProductDetailDisplayFeatureSummaryComponent implements OnInit, OnChanges {
  @Input() product: ProductInterface;
  @Input() variant?: ProductVariantInterface;

  @Input() certification: CertificationInterface;
  @Input() commonFeatures?: ProductCommonFeatureInterface[];
  @Input() ptg_names: string[] = []; // in use? obsolet?

  @Input() licenseModels: string[]; // in use? obsolet?

  version: VariantVersionInterface;
  versionBack: VariantVersionInterface;

  productFeatures: string[] = []; // "Stärken des Produktes"
  displayedColumnsForCommonFeatures: string[] = ['feature', 'value'];
  allFeatures: string[] = []; // attributes of all ptgVersions and all Versions and all Variants
  comparisonRows: FeatureComparisonRow[] = [];

  public productFeatureToggle: boolean = false; // not used for toggle anymore, but maybe to show/hide section if features exist
  public ptgToggle: boolean = false; // not used for toggle anymore, but maybe to show/hide section if features exist
  public commonFeaturesToggle: boolean = false; // not used for toggle anymore, but maybe to show/hide section if features exist
  public attributeToggle: boolean = false; // not used for toggle anymore, but maybe to show/hide section if features exist

  productCommonFeatures: ProductCommonFeatureInterface[] = []; // "Übergordnete Auswahlkriterien"
  ptgVersionFeatures: ProductTypeGroupFeaturesDisplayInterface[] = [];
  ptgGroups: PtgGroup[] = [];

  versionColumns: VersionColumn[] = [];
  displayedColumns: string[] = [];
  displayedColumnsWithClose: string[] = [];
  displayedColumnsWithType: string[] = [];

  chipOnlyPtgGroups: PtgGroup[] = [];
  tablePtgGroups: PtgGroup[] = [];

  variantsList: ProductVariantInterface[] = []; // all variants of product
  variantsListFiltered: ProductVariantInterface[] = []; // selected variant in drop down menu

  selectedComparisonTabIndex: number = 0;
  allPtgFeatures: any[] = [];
  loading: boolean = false;

  @Input() preview?: boolean = false;

  @ViewChild('comparisonSection', { read: ElementRef }) comparisonSection: ElementRef;

  get displayedPtgs() {
    if (!this.allPtgFeatures || !Array.isArray(this.allPtgFeatures)) {
      return [];
    }
    // const fulfilledPtgFeatures = this.allPtgFeatures.filter(
    //   ptg => ptg.doesProjectFulfillAllFeaturesOfPTGVersion
    // );
    // if (fulfilledPtgFeatures.length > 0) {
    //   return fulfilledPtgFeatures;
    // }
    if (!this.ptgVersionFeatures || !Array.isArray(this.ptgVersionFeatures)) {
      return [];
    }
    // return this.ptgVersionFeatures.slice(0, 3);
    return this.ptgVersionFeatures;
  }
  
  get displayedFetures() { // "Stärken des Produktes"
    if (!this.productFeatures || !Array.isArray(this.productFeatures)) {
      return [];
    }
    return this.productFeatures.slice(0, 10);
  }
  
  constructor(
    private commonFeatureService: CommonFeatureService,
    private cd: ChangeDetectorRef
  ) {}


  ngOnInit() {
  }

  public toggleMinimization(ptg): void {
    ptg.minimized = !ptg.minimized;
  }

  ngOnChanges(products: SimpleChanges) {
    this.loading = true;
    
    // regular product view
    if (products.product && this.product && this.product.productVariants && !this.preview) {
      this.prepareComparisonData();
    }

    // changes to product?
    if (products != null && products.product) {
      this.product = products.product.currentValue;

      if (this.product && this.product.productVariants) {
        // Defines list of variants
        this.variantsList = this.product.productVariants;
        // regular product view
        if (!this.preview) {
          // ---------------------------------------------------------------------------------------------------------------------------------------------------
          // Vorsicht hier wird die letzte Version irgendeiner Variante definiert
          const latestVersion = this.getLatestVersionByName(this.product.productVariants);
          if (latestVersion) {
            this.versionBack = latestVersion;
            this.allPtgFeatures = this.getAllPTGFeaturesFromVariants();
            //this.onVersionSelected(latestVersion);
          }
        } else {  
          // preview in product create form
          // Does not work for version add / edit forms
          this.versionBack = this.product.productVariants[0].variantVersions[0]; 
          this.allPtgFeatures = this.getAllPTGFeaturesFromVariants();
        }
      }
    }

    // Defines features
    if (this.product.productVariants != null) {
      this.product.productVariants.map((x) => {
        // why map und why this.version = x? x = variant
        this.version = x;
        this.extractAllFeaturesAndRows();
      });

      this.productFeatures = this.product.features || []; // "Stärken des Produktes"

      // commoneFeatures
      // regular product view
      if(!this.preview){
        this.commonFeatureService
          .getFeaturesForProduct(this.product.id)
          .subscribe((success: ProductCommonFeatureInterface[]) => {
            this.productCommonFeatures = success;
            this.commonFeaturesToggle = success.length > 0;
          });  
      } else if(this.preview){
        // preview in product create form
        this.productCommonFeatures = this.commonFeatures;
        this.commonFeaturesToggle = this.productCommonFeatures.length > 0;
        }
      this.loading = false;
    }

    // Defines selected variant for regular product view
    if (products.variant && products.variant.currentValue && !this.preview) {
      const selectedVariant = products.variant.currentValue;
      const selectedVariantId = typeof selectedVariant === 'object' ? selectedVariant.id : selectedVariant;
      this.variantsListFiltered = [...this.product.productVariants.filter(
        (variant) => variant.id === selectedVariantId
      )];
      
      if (this.variantsListFiltered.length > 0 && this.variantsListFiltered[0].variantVersions) {
        const latestVersion = this.getLatestVersionByName(this.variantsListFiltered);
        if (latestVersion) {
          this.version = latestVersion;
          this.extractAllFeaturesAndRows();
          this.onVersionSelected(latestVersion);
        }
      }
      this.selectedComparisonTabIndex = 0;
      this.loading = false;
      return;
    }
  }


  // Changed sorting from name to id
  private getLatestVersionByName(variants: ProductVariantInterface[]): VariantVersionInterface | null {
    const allVersions: VariantVersionInterface[] = [];
    for (const variant of variants) {
      if (variant.variantVersions && variant.variantVersions.length > 0) {
        allVersions.push(...variant.variantVersions);
      }
    }
    if (allVersions.length === 0) return null;
     // Why alphabetic sorting by name?
    // allVersions.sort((a, b) => a.name.localeCompare(b.name));
    // return allVersions[allVersions.length - 1];

    // sorting by id number
    const sortedVersions = [...allVersions].sort((a, b) => a.id - b.id);
    const lastVersion = sortedVersions[sortedVersions.length - 1];

    if (lastVersion?.status === 'ACTIVE') {
      return lastVersion;
    }
        
    const previousActive = [...sortedVersions]
      .reverse()
      .find((v) => v.status === 'ACTIVE');

    return previousActive ?? null;
  }


  private prepareComparisonData(): void {
    const versionColumns: VersionColumn[] = [];
    const versionKeyToVersion: { [key: string]: VariantVersionInterface } = {};

    for (const variant of this.product.productVariants) {
      if (!variant.variantVersions) continue;
      for (const version of variant.variantVersions) {
        const key = `${variant.id}_${version.id}`;
        versionColumns.push({
          key,
          variantName: variant.name,
          versionName: version.name,
          variant: variant,
        });
        versionKeyToVersion[key] = version;
      }
    }
    const ptgMap: { [ptgName: string]: { ptgDescription: string, featureMap: { [featureName: string]: FeatureRow } } } = {};

    for (const variant of this.product.productVariants) {
      if (!variant.variantVersions) continue;
      for (const version of variant.variantVersions) {
        const versionKey = `${variant.id}_${version.id}`;
        if (!version.ptgVersions) continue;
        for (const ptg of version.ptgVersions) {
          if (!ptgMap[ptg.ptgName]) {
            ptgMap[ptg.ptgName] = {
              ptgDescription: ptg.ptgDescription || '',
              featureMap: {}
            };
          }
          if (!ptg.attributeValidations) continue;
          for (const attrVal of ptg.attributeValidations) {
            const featureName = attrVal.attribute.name;
            if (!ptgMap[ptg.ptgName].featureMap[featureName]) {
              ptgMap[ptg.ptgName].featureMap[featureName] = {
                featureName,
                optionalValidation: attrVal.optionalValidation,
                datatype: attrVal.attribute.datatype,
                versionMap: {}
              };
            }
            this.versionBack = version;
            ptgMap[ptg.ptgName].featureMap[featureName].versionMap[versionKey] = {
              value: this.getValidationValue2(attrVal, this.getValidationValue(attrVal)),
              datatype: attrVal.attribute.datatype
            };
          }
        }
      }
    }
    this.ptgGroups = Object.entries(ptgMap).map(([ptgName, ptgData]) => ({
      ptgName,
      ptgDescription: ptgData.ptgDescription,
      features: Object.values(ptgData.featureMap),
      minimized: true,
      mandatoryFeatures: Object.values(ptgData.featureMap),
      optionalFeatures: Object.values(ptgData.featureMap),
      sortedFeatures: Object.values(ptgData.featureMap)
        .sort((a, b) => a.featureName.localeCompare(b.featureName)),
    }));
    this.ptgGroups.sort((a, b) => {
      if (a.features.length === 0 && b.features.length > 0) return -1;
      if (a.features.length > 0 && b.features.length === 0) return 1;
      return a.ptgName.localeCompare(b.ptgName);
    });
    this.chipOnlyPtgGroups = this.ptgGroups.filter(g => g.features.length === 0);
    this.tablePtgGroups = this.ptgGroups.filter(g => g.features.length > 0);
    for (const ptg of this.tablePtgGroups) {
      ptg.mandatoryFeatures = ptg.features
        .filter(f => !f.optionalValidation)
      ptg.optionalFeatures = ptg.features
        .filter(f => f.optionalValidation)
      ptg.sortedFeatures = ptg.features
        .map(f => ({...f,type: f.optionalValidation ? 'Optional' : 'Pflicht' }))
        .sort((a, b) => {if (a.type !== b.type) {return a.type === 'Pflicht' ? -1 : 1; }
          return a.featureName.localeCompare(b.featureName);
        });
    }
    this.versionColumns = versionColumns;
    this.displayedColumns = ['feature', ...versionColumns.map(c => c.key)];
    this.displayedColumnsWithClose = [...this.displayedColumns];
    this.displayedColumnsWithType = ['feature', ...this.versionColumns.map(c => c.key)];
  }


  private getValidationValue(
    attribute: PtgAttributeValidationInterface,
    version?: VariantVersionInterface
  ): string {
    const sourceVersion = version ?? this.versionBack;
    const validation = sourceVersion?.attributeValidationValues?.find(
      (validationValue) =>
        validationValue.attribute.id === attribute.attribute.id
    );
    const validationValue = validation == null ? '' : validation.value;
    if (
      attribute.attribute.datatype === 'LIST' &&
      validationValue != null
    ) {
      return validationValue.replace(/;/g, ', ');
    }
    return validationValue;
  }


  private getValidationValue2(attrVal: PtgAttributeValidationInterface, value: string): any {
    // BOOLEAN: use true/false, others: show value as string
    const validation = attrVal.attribute.validations[0];
    switch (attrVal.attribute.datatype) {
      case 'NUMERIC':
        return this.isNumberInRange(
          Number(value),
          validation.minSize,
          validation.maxSize
        );
      case 'BOOLEAN':
        return (
          attrVal.attribute.validations[0].value == null ||
          value == null ||
          attrVal.attribute.validations[0].value + '' == value + ''
        );
      case 'LIST':
        return this.isListValid(
          validation.values,
          validation.minSize,
          validation.maxSize,
          value.split(', ')
        );
      case 'STRING':
        return this.isNumberInRange(
          value.length,
          validation.minSize,
          validation.maxSize
        );
    }
    return '';
  }


  private getAllPTGFeaturesFromVariants(): ProductTypeGroupFeaturesDisplayInterface[] {
    const allPTGFeatures: ProductTypeGroupFeaturesDisplayInterface[] = [];

    for (const variant of this.variantsList) {
      if (variant.variantVersions) {
        for (const version of variant.variantVersions) {
          if (version.ptgVersions) {
            for (const ptgVersion of version.ptgVersions) {
              const ptgFeature = this.getPTGFeatures(ptgVersion, version);
              
              allPTGFeatures.push(ptgFeature);
            }
          }
        }
      }
    }

    // Deduplicate by ptgName, keeping the fulfilled one if present
    const ptgMap = new Map<string, ProductTypeGroupFeaturesDisplayInterface>();

    for (const ptgFeature of allPTGFeatures) {
      const name = ptgFeature.ptgName;
      if (!ptgMap.has(name)) {
        // First occurrence, add it
        ptgMap.set(name, ptgFeature);
      }
      if (
        ptgFeature.doesProjectFulfillAllFeaturesOfPTGVersion
      ) {
        // Replace with fulfilled version if previous was not fulfilled
        ptgMap.set(name, ptgFeature);
      }
      // If already fulfilled, do nothing (keep the first fulfilled one)
    }

    return Array.from(ptgMap.values());
  }


  public onVersionSelected(version: VariantVersionInterface): void {
    this.version = version;
    this.updatePTGlist(version);
    this.attributeToggle = (version.ptgVersions ?? []).some(
      (ptgVersion) =>
        ptgVersion.attributeValidations != null &&
        ptgVersion.attributeValidations.length > 0
    );
    this.productFeatureToggle =
      this.productFeatures.length > 0 ? true : false;
    this.ptgToggle = this.ptgVersionFeatures.length > 0 ? true : false;
  }


  private updatePTGlist(version: VariantVersionInterface): void {
    const ptgs = [...(version.ptgVersions ?? [])];

    const hasDescriptionOrder = ptgs.some(
      ptg => this.getOrderFromDescription(ptg.description) !== null);

    let sortedPtgVersions: VariantVersionInterface['ptgVersions'];

    if (hasDescriptionOrder) {
      sortedPtgVersions = ptgs.sort((a, b) => {
        const orderA = this.getOrderFromDescription(a.description) ?? Number.MAX_SAFE_INTEGER;
        const orderB = this.getOrderFromDescription(b.description) ?? Number.MAX_SAFE_INTEGER;
        return orderA - orderB;
      });

    } else { 
      const hasCustomOrder = ptgs.some((v) => v.order && v.order > 0);
      sortedPtgVersions = hasCustomOrder
        ? [...ptgs].sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
        : [...ptgs].sort((a, b) =>
            a.ptgName.toLowerCase().localeCompare(b.ptgName.toLowerCase())
          );
    }

    this.ptgVersionFeatures = sortedPtgVersions.map((ptgVersion) =>
      this.getPTGFeatures(ptgVersion, version)
    );
    this.version = version;
    this.ptg_names = version.productTypeNames ?? [];
  }

  
  private getOrderFromDescription(description?: string): number | null {
    if (!description) {
      return null;
    }

    const match = description.match(/^<<>>\s*(\d+)\s*,\s*(\d+)$/);
    if (!match) {
      return null;
    }

    return Number(match[2]); // second number is the order (first is the id)
  }


  private getPTGFeatures(
    ptgVersion: PtgVersionInterface,
    version: VariantVersionInterface
  ): ProductTypeGroupFeaturesDisplayInterface {
    const ptgVersionFeatures: ProductTypeGroupFeaturesDisplayInterface = {
      ptgName: ptgVersion.ptgName ?? '',
      ptgDescription: this.removeHTMLTags(ptgVersion.ptgDescription),
      mandatoryFeatures: [],
      optionalFeatures: [],
      doesProjectFulfillAllFeaturesOfPTGVersion: true,
      isCertified: this.isPtgCertified(ptgVersion.ptgName, version),
      order: ptgVersion?.order,
    };

    for (const attributeVal of ptgVersion.attributeValidations) {
      const feature: ProductTypeGroupFeatureDisplayInterface = {
        featureName: attributeVal.attribute.name,
        featureDescription: attributeVal.attribute.description,
        featureValidation: this.getValidationValue(attributeVal, version),
        datatype: attributeVal.attribute.datatype
      };
      if (attributeVal.optionalValidation) {
        ptgVersionFeatures.optionalFeatures.push(feature);
      } else {
        ptgVersionFeatures.mandatoryFeatures.push(feature);
        if (
          !this.isAttributeValueFulfillingValidation(
            attributeVal.attribute,
            feature.featureValidation + ''
          )
        ) {
          ptgVersionFeatures.doesProjectFulfillAllFeaturesOfPTGVersion =
            false;
        }
      }
    }
    if (ptgVersionFeatures.mandatoryFeatures.length === 0) {
      ptgVersionFeatures.doesProjectFulfillAllFeaturesOfPTGVersion =
        false;
    }
    return ptgVersionFeatures;
  }

  private isPtgCertified(
    ptgName: string,
    version: VariantVersionInterface
  ): boolean {
    return (version.certificationVariantVersions ?? []).some(
      (certVersion) =>
        (certVersion.ptgVersions ?? []).some(
          (certPtg) => certPtg.ptgName === ptgName
        )
    );
  }

  private removeHTMLTags(text: string): string {
    return text.replace(/<[^>]*>/g, '');
  }


  private extractAllFeaturesAndRows(): void {
    const featureSet = new Set<string>();
    const rows: FeatureComparisonRow[] = [];

    for (const variant of this.product.productVariants) {
      if (!variant.variantVersions) continue;
      for (const version of variant.variantVersions) {
        const versionFeatures = new Set<string>();

        if (version.ptgVersions) {
          for (const ptgVersion of version.ptgVersions) {
            if (ptgVersion.attributeValidations) {
              for (const attributeValidation of ptgVersion.attributeValidations) {
                if (attributeValidation.attribute && attributeValidation.attribute.name) {
                  versionFeatures.add(attributeValidation.attribute.name);
                  featureSet.add(attributeValidation.attribute.name);
                }
              }
            }
          }
        }

        rows.push({
          variantName: variant.name,
          versionName: version.name,
          features: versionFeatures,
          version: version
        });
      }
    }

    this.allFeatures = Array.from(featureSet).sort();
    this.comparisonRows = rows;
  }


  private isAttributeValueFulfillingValidation(
    attribute: AttributeInterface,
    value: string
  ) {
    const validation = attribute.validations[0];
    switch (attribute.datatype) {
      case 'NUMERIC':
        return this.isNumberInRange(
          Number(value),
          validation.minSize,
          validation.maxSize
        );
      case 'BOOLEAN':
        return (
          attribute.validations[0].value == null ||
          value == null ||
          attribute.validations[0].value + '' == value + ''
        );
      case 'LIST':
        return this.isListValid(
          validation.values,
          validation.minSize,
          validation.maxSize,
          value.split(', ')
        );
      case 'STRING':
        return this.isNumberInRange(
          value.length,
          validation.minSize,
          validation.maxSize
        );
    }
  }


  private isListValid(
    validationValues: string[],
    minCount: number,
    maxCount: number,
    selectedValues: string[]
  ): boolean {
    for (const selectedValue of selectedValues) {
      if (!validationValues.includes(selectedValue)) {
        return false;
      }
    }
    return this.isNumberInRange(selectedValues.length, minCount, maxCount);
  }


  private isNumberInRange(value: number, min: number, max: number): boolean {
    return (min == null || min <= value) && (max == null || max >= value);
  }


  scrollToComparison(): void {
    if (this.comparisonSection) {
      this.comparisonSection.nativeElement.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  }
}

interface VersionColumn {
  key: string; // unique key for this version (e.g. variantId_versionId)
  variantName: string;
  versionName: string;
  variant: VariantVersionInterface;
}

interface FeatureCell {
  value: any;
  datatype: string;
}

interface FeatureRow {
  featureName: string;
  optionalValidation: boolean;
  datatype: string;
  versionMap: { [versionKey: string]: FeatureCell };
}

interface PtgGroup {
  ptgName: string;
  ptgDescription: string;
  features: FeatureRow[];
  minimized: boolean;
  mandatoryFeatures: FeatureRow[];
  optionalFeatures: FeatureRow[];
  sortedFeatures: FeatureRow[];
}

interface VariantPTGFeatures {
  variantId: number;
  variantName: string;
  ptgs: {
    ptgId: number;
    ptgName: string;
    ptgDescription?: string;
    features: {
      featureId: number;
      featureName: string;
      featureDescription?: string;
      datatype: string;
      optional: boolean;
      validation: ValidationInterface;
      optionalValidation: boolean;
    }[];
  }[];
}